import { ComponentDataSourceService } from '../../component-data-source.service';
import { DataSourceFunction } from '../../component-data-source.service';
import { LoadDataParams } from '../../../../interfaces/DataSource/DataSourceParams.interface';
import { Observable, of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';
import { environment } from '../../../../environment/environment';
import { Router } from '@angular/router';
import { fetchParticipationRegisterOpen$, PARTICIPATION_REGISTER_CLOSED_FALLBACK } from './event-participation-register-open.utils';

const EVENT_GUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const LOG_PREFIX = '[event_visibility_ds]';

/**
 * Visibility data source for the event participate form catering page (page2).
 * Returns { visible: boolean } from backend GET /events/:guid/participation/show-catering.
 * Also hidden when registration is closed (participation/register-open), so catering is not shown alone after deadline.
 */
export function event_show_catering_page(service: ComponentDataSourceService): DataSourceFunction {
  return {
    name: 'event_show_catering_page',
    description: 'Whether to show the catering page (false when user is already participating, excluding cancellation). For visibilityDataSource on page2.',
    execute: (_params?: LoadDataParams): Observable<{ visible: boolean; message?: string }> => {
      const router = service.injector.get(Router);
      const pathFromRouter = (router.url || '').split('?')[0];
      const pathForGuid = pathFromRouter || (typeof window !== 'undefined' ? window.location?.pathname || '' : '');
      const pathSegments = pathForGuid.split('/');
      let eventGuid = pathSegments.find((segment) => EVENT_GUID_REGEX.test(segment));
      if (!eventGuid && typeof window !== 'undefined' && window.location?.pathname) {
        eventGuid = window.location.pathname.split('/').find((segment) => EVENT_GUID_REGEX.test(segment)) ?? undefined;
      }

      if (!eventGuid) {
        return of({ visible: true });
      }

      return fetchParticipationRegisterOpen$(service, _params).pipe(
        switchMap(({ open, message }) => {
          if (!open) {
            return of({ visible: false, message: message || PARTICIPATION_REGISTER_CLOSED_FALLBACK });
          }
          return service.http
            .get<{ visible?: boolean; data?: { visible?: boolean } }>(
              `${environment.apiUrl}/events/${eventGuid}/participation/show-catering`
            )
            .pipe(
              map((res) => {
                const visible = res?.visible === true || res?.data?.visible === true;
                return { visible };
              }),
              catchError((err) => {
                console.warn(LOG_PREFIX, 'event_show_catering_page', 'error', err?.message || err, { eventGuid, visible: true });
                return of({ visible: true });
              })
            );
        }),
        catchError((err) => {
          console.warn(LOG_PREFIX, 'event_show_catering_page', 'register-open error', err?.message || err, { eventGuid, visible: true });
          return of({ visible: true });
        })
      );
    }
  };
}
